var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"cover-top-laminate","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Ламинат_Блик"}},[_c('image',{attrs:{"transform":"translate(0 4)","href":_vm.params.laminateGlow}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }